














































































































































import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { NormsServices } from '../api/NormsServices';
import { EventBus, hasElements, TypeEventBus, sortObjectByPropertyName, getIndexFromList } from '../../core/utils';
import Loading from 'vue-loading-overlay';
import $ from 'jquery';

@Component({
    components: {}
})
export default class PreviewDatabase extends Vue {
    @Prop() allCategories: any;
    @Prop() previewData: any;
    @Prop({ default: false }) previewFromList: boolean;
    noDataText: string = 'No hay datos para mostrar';
    showModalDownloadFiles: boolean = true;
    sectionNames: any = [
        {
            id: 'initial_conf',
            name: 'Configuración Inicial'
        },
        {
            id: 'slots',
            name: 'Slots'
        },
        {
            id: 'es',
            name: 'Electronic system'
        },
        {
            id: 'ecus',
            name: 'Ecus'
        },
        {
            id: 'frames',
            name: 'Frames'
        },
        {
            id: 'parameter',
            name: 'Parámetros'
        },
        {
            id: 'special',
            name: 'Parámetros especiales'
        },
        {
            id: 'calculated',
            name: 'Parámetros calculados'
        },
        {
            id: 'measured',
            name: 'Parámetros medidos'
        }
    ];
    model: any = [];
    // previewData: any = [];

    @Emit()
    prevStep() {}

    mounted() {
        // console.log('preview data', this.previewData);
    }

    getSectionName(i, item) {
        let index = getIndexFromList(this.sectionNames, 'id', i);
        let sectionName = this.sectionNames[index]['name'];
        let quantity = ' (' + item.length + ')';

        if (sectionName !== 'Configuración Inicial') {
            return sectionName + quantity;
        } else {
            return sectionName;
        }
    }

    triggerBackClick() {
        if (this.previewFromList) {
            this.$emit('close-modal');
        } else {
            this.prevStep();
        }
    }

    close() {
        this.model = [];
    }
}
